import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
};

export type Query = {
  __typename?: 'Query';
  fund?: Maybe<Fund>;
  funds?: Maybe<Array<Maybe<Fund>>>;
  fundInvestment?: Maybe<FundInvestment>;
  fundInvestments?: Maybe<Array<Maybe<FundInvestment>>>;
  fundScenario?: Maybe<FundScenario>;
  fundScenarios?: Maybe<Array<Maybe<FundScenario>>>;
  fundScenarioInvestmentScenarios?: Maybe<
    Array<Maybe<FundScenarioInvestmentScenario>>
  >;
  capTableScenario?: Maybe<CapTableScenario>;
  capTableScenarios?: Maybe<Array<Maybe<CapTableScenario>>>;
  company?: Maybe<Company>;
  companies?: Maybe<Array<Maybe<Company>>>;
};

export type QueryFundArgs = {
  id: Scalars['UUID'];
};

export type QueryFundInvestmentArgs = {
  id: Scalars['UUID'];
};

export type QueryFundInvestmentsArgs = {
  fundId: Scalars['UUID'];
};

export type QueryFundScenarioArgs = {
  id: Scalars['UUID'];
};

export type QueryFundScenariosArgs = {
  fundId: Scalars['UUID'];
};

export type QueryFundScenarioInvestmentScenariosArgs = {
  fundInvestmentId: Scalars['UUID'];
};

export type QueryCapTableScenarioArgs = {
  id: Scalars['UUID'];
};

export type QueryCompanyArgs = {
  id: Scalars['UUID'];
};

export type Fund = {
  __typename?: 'Fund';
  id: Scalars['UUID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isSubfund: FundsFundIsSubfundChoices;
  parentFund?: Maybe<Fund>;
  interestRate: Scalars['Float'];
  managementFee: Scalars['Float'];
  carriedInterest: Scalars['Float'];
  closeDate?: Maybe<Scalars['Date']>;
  useManualIrr: Scalars['Boolean'];
  apiFundId: Scalars['String'];
  fundinvestmentSet: Array<FundInvestment>;
  subfunds: Array<Fund>;
  scenarios: Array<FundScenario>;
  bookValue?: Maybe<Scalars['Float']>;
  currencySign?: Maybe<Scalars['String']>;
  grossIrr?: Maybe<Scalars['Float']>;
  grossMultiple?: Maybe<Scalars['Float']>;
  investedCapital?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum FundsFundIsSubfundChoices {
  /** Fund */
  False = 'FALSE',
  /** Sub fund */
  True = 'TRUE',
}

export type FundInvestment = {
  __typename?: 'FundInvestment';
  id: Scalars['UUID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  fund: Fund;
  company: Company;
  status: FundInvestmentsFundInvestmentStatusChoices;
  investmentDate?: Maybe<Scalars['Date']>;
  inactivityDate?: Maybe<Scalars['Date']>;
  includeInScenariosCalcs: Scalars['Boolean'];
  ipoName: Scalars['String'];
  sharePrice?: Maybe<Scalars['Float']>;
  redeemedShares?: Maybe<Scalars['Int']>;
  escrow?: Maybe<Scalars['Float']>;
  escrowDate?: Maybe<Scalars['Date']>;
  comments: Scalars['String'];
  scenarios: Array<FundScenarioInvestmentScenario>;
  capTableUrl?: Maybe<Scalars['String']>;
  ev?: Maybe<Scalars['Float']>;
  ownershipPercent?: Maybe<Scalars['Float']>;
  investedCapital?: Maybe<Scalars['Float']>;
  irr?: Maybe<Scalars['Float']>;
  multiple?: Maybe<Scalars['Float']>;
  nav?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  id: Scalars['UUID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  name: Scalars['String'];
  ceoName: Scalars['String'];
  contactName1: Scalars['String'];
  contactName2: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
  headquarters: Scalars['String'];
  address1: Scalars['String'];
  address2: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  url: Scalars['String'];
  description: Scalars['String'];
  foundingDate?: Maybe<Scalars['Date']>;
  blurb: Scalars['String'];
  exitDate?: Maybe<Scalars['Date']>;
  updateDate: Scalars['Date'];
  logo?: Maybe<Scalars['String']>;
  bgPhoto?: Maybe<Scalars['String']>;
  documentId: Scalars['String'];
  documentVersionId: Scalars['String'];
  totalShares?: Maybe<Scalars['Int']>;
  status: CompaniesCompanyStatusChoices;
  statusDate?: Maybe<Scalars['Date']>;
  documentsDump: Scalars['String'];
};

/** An enumeration. */
export enum CompaniesCompanyStatusChoices {
  /** Active */
  A_10 = 'A_10',
  /** Inactive */
  A_20 = 'A_20',
}

/** An enumeration. */
export enum FundInvestmentsFundInvestmentStatusChoices {
  /** Active */
  A_10 = 'A_10',
  /** Inactive - Written Off */
  A_20 = 'A_20',
  /** Inactive - Exit */
  A_30 = 'A_30',
  /** Inactive - Full Position Sale */
  A_40 = 'A_40',
  /** Inactive - Other */
  A_50 = 'A_50',
}

export type FundScenarioInvestmentScenario = {
  __typename?: 'FundScenarioInvestmentScenario';
  id: Scalars['UUID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  capTableScenario?: Maybe<CapTableScenario>;
  exitAmount: Scalars['Float'];
  exitDate?: Maybe<Scalars['Date']>;
  dilution?: Maybe<Scalars['Float']>;
  totalProceeds?: Maybe<Scalars['Float']>;
  irr?: Maybe<Scalars['Float']>;
  multiple?: Maybe<Scalars['Float']>;
};

export type CapTableScenario = {
  __typename?: 'CapTableScenario';
  id: Scalars['UUID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  name: Scalars['String'];
  fundscenarioinvestmentscenarioSet: Array<FundScenarioInvestmentScenario>;
};

export type FundScenario = {
  __typename?: 'FundScenario';
  id: Scalars['UUID'];
  dateCreated: Scalars['DateTime'];
  dateUpdated: Scalars['DateTime'];
  defaultDilution: Scalars['Float'];
  defaultExitDate: Scalars['Date'];
  name: Scalars['String'];
  position: Scalars['Int'];
  fundscenarioinvestmentscenarioSet: Array<FundScenarioInvestmentScenario>;
  bookValue?: Maybe<Scalars['Float']>;
  grossIrr?: Maybe<Scalars['Float']>;
  grossMultiple?: Maybe<Scalars['Float']>;
  investedCapital?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  capTableScenariosAdd?: Maybe<Array<Maybe<CapTableScenario>>>;
  capTableScenarioChange?: Maybe<Array<Maybe<CapTableScenario>>>;
  /** Deletes scenarios by list of IDs and returns amount of deleted rows.  */
  capTableScenariosDelete?: Maybe<Scalars['Int']>;
  fundScenariosAdd?: Maybe<Array<Maybe<FundScenario>>>;
  fundScenariosChange?: Maybe<Array<Maybe<FundScenario>>>;
  /** Triggers datasync to calculate FundScenarios  */
  fundScenariosCalculate?: Maybe<Scalars['Boolean']>;
  /** Deletes scenarios by list of IDs and returns amount of deleted rows.  */
  fundScenariosDelete?: Maybe<Scalars['Int']>;
  fundScenarioInvestmentScenariosAdd?: Maybe<
    Array<Maybe<FundScenarioInvestmentScenario>>
  >;
  fundScenarioInvestmentScenariosChange?: Maybe<
    Array<Maybe<FundScenarioInvestmentScenario>>
  >;
  /** Deletes scenarios by list of IDs and returns amount of deleted rows.  */
  fundScenarioInvestmentScenariosDelete?: Maybe<Scalars['Int']>;
};

export const CalculateFundScenarios = gql`
  mutation fundScenariosCalculate($fundId: UUID!, $investmentId: UUID) {
    fundScenariosCalculate(fundId: $fundId, investmentId: $investmentId)
  }
`;
export const ChangeFundInvestment = gql`
  mutation fundInvestmentChange($fundInvestments: [FundInvestmentChangeItem]!) {
    fundInvestmentChange(fundInvestments: $fundInvestments) {
      id
      includeInScenariosCalcs
    }
  }
`;
export const AddCapTableScenarios = gql`
  mutation capTableScenariosAdd($scenarios: [CapTableScenarioAddItem]!) {
    capTableScenariosAdd(scenarios: $scenarios) {
      id
      name
    }
  }
`;

export const AddFundScenarios = gql`
  mutation AddFundScenarios($scenarioSets: [FundScenariosAddSet]!) {
    fundScenariosAdd(scenarioSets: $scenarioSets) {
      id
    }
  }
`;

export const ChangeFundScenarios = gql`
  mutation ChangeFundScenarios($scenarios: [FundScenariosChangeItem]!) {
    fundScenariosChange(scenarios: $scenarios) {
      id
    }
  }
`;

export const FundScenarioInvestmentScenariosAdd = gql`
  mutation FundScenarioInvestmentScenariosAdd(
    $scenarioSets: [FundScenarioInvestmentScenarioAddSet]!
  ) {
    fundScenarioInvestmentScenariosAdd(scenarioSets: $scenarioSets) {
      id
    }
  }
`;

export const fundScenarioInvestmentScenariosChange = gql`
  mutation fundScenarioInvestmentScenariosChange(
    $scenarios: [FundScenarioInvestmentScenariosChangeItem]!
  ) {
    fundScenarioInvestmentScenariosChange(scenarios: $scenarios) {
      id
    }
  }
`;

export const DeleteFundScenarios = gql`
  mutation DeleteFundScenarios($scenarios: [UUID]!) {
    fundScenariosDelete(scenarios: $scenarios)
  }
`;

export type MutationCapTableScenariosAddArgs = {
  scenarios: Array<Maybe<CapTableScenarioAddItem>>;
};

export type MutationCapTableScenarioChangeArgs = {
  scenarios: Array<Maybe<CapTableScenarioChangeItem>>;
};

export type MutationCapTableScenariosDeleteArgs = {
  scenarios: Array<Maybe<Scalars['UUID']>>;
};

export type MutationFundScenariosAddArgs = {
  scenarioSets: Array<Maybe<FundScenariosAddSet>>;
};

export type MutationFundScenariosChangeArgs = {
  scenarios: Array<Maybe<FundScenariosChangeItem>>;
};

export type MutationFundScenariosCalculateArgs = {
  fundId: Scalars['UUID'];
};

export type MutationFundScenariosDeleteArgs = {
  scenarios: Array<Maybe<Scalars['UUID']>>;
};

export type MutationFundScenarioInvestmentScenariosAddArgs = {
  scenarioSets: Array<Maybe<FundScenarioInvestmentScenarioAddSet>>;
};

export type MutationFundScenarioInvestmentScenariosChangeArgs = {
  scenarios: Array<Maybe<FundScenarioInvestmentScenariosChangeItem>>;
};

export type MutationFundScenarioInvestmentScenariosDeleteArgs = {
  scenarios: Array<Maybe<Scalars['UUID']>>;
};

export type FundInvestmentChangeItem = {
  includeInScenariosCalcs: Scalars['Boolean'];
  id: Scalars['UUID'];
};

export type CapTableScenarioAddItem = {
  name: Scalars['String'];
};

export type CapTableScenarioChangeItem = {
  name: Scalars['String'];
  id: Scalars['UUID'];
};

export type FundScenariosAddSet = {
  fundId: Scalars['UUID'];
  scenarios: Array<Maybe<FundScenariosAddItem>>;
};

export type FundScenariosDeleteSet = {
  scenarios: Scalars['UUID'];
};

export type FundScenariosAddItem = {
  defaultDilution: Scalars['Float'];
  defaultExitDate: Scalars['Date'];
  name: Scalars['String'];
};

export type FundScenariosChangeItem = {
  defaultDilution: Scalars['Float'];
  defaultExitDate: Scalars['Date'];
  name: Scalars['String'];
  id: Scalars['UUID'];
};

export type FundScenarioInvestmentScenarioAddSet = {
  fundInvestmentId: Scalars['UUID'];
  scenarios: Array<Maybe<FundScenarioInvestmentScenarioAddItem>>;
};

export type FundScenarioInvestmentScenarioAddItem = {
  capTableScenarioId: Scalars['UUID'];
  exitAmount: Scalars['Float'];
  exitDate: Scalars['Date'];
  dilution: Scalars['Float'];
  fundScenarioId: Scalars['UUID'];
};

export type FundScenarioInvestmentScenariosChangeItem = {
  capTableScenarioId: Scalars['UUID'];
  existAmount: Scalars['Float'];
  exitDate: Scalars['Date'];
  dilution: Scalars['Float'];
  id: Scalars['UUID'];
};

export type GetFundQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type GetFundQuery = { __typename?: 'Query' } & {
  fund?: Maybe<
    { __typename?: 'Fund' } & Pick<
      Fund,
      | 'id'
      | 'bookValue'
      | 'currencySign'
      | 'grossIrr'
      | 'grossMultiple'
      | 'investedCapital'
    >
  >;
};

export type GetFundInvestmentsQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type GetFundInvestmentsQuery = { __typename?: 'Query' } & {
  fundInvestments?: Maybe<
    Array<
      Maybe<
        { __typename?: 'FundInvestment' } & Pick<
          FundInvestment,
          | 'id'
          | 'status'
          | 'investedCapital'
          | 'ownershipPercent'
          | 'nav'
          | 'ev'
          | 'multiple'
          | 'irr'
        > & {
            company: { __typename?: 'Company' } & Pick<
              Company,
              'name' | 'documentId'
            >;
          }
      >
    >
  >;
};

export type GetFundScenariosQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type GetFundScenariosQuery = { __typename?: 'Query' } & {
  fundScenarios?: Maybe<
    Array<
      Maybe<
        { __typename?: 'FundScenario' } & Pick<
          FundScenario,
          'id' | 'defaultDilution' | 'defaultExitDate'
        >
      >
    >
  >;
};

export const GetFundDocument = gql`
  query GetFund($id: UUID!) {
    fund(id: $id) {
      id
      bookValue
      currencySign
      grossIrr
      grossMultiple
      investedCapital
    }
  }
`;

export const GetCaptableScenarios = gql`
  query capTableScenarios {
    capTableScenarios {
      id
      name
    }
  }
`;

/**
 * __useGetFundQuery__
 *
 * To run a query within a React component, call `useGetFundQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFundQuery(
  baseOptions?: Apollo.QueryHookOptions<GetFundQuery, GetFundQueryVariables>,
) {
  return Apollo.useQuery<GetFundQuery, GetFundQueryVariables>(
    GetFundDocument,
    baseOptions,
  );
}
export function useGetFundLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFundQuery,
    GetFundQueryVariables
  >,
) {
  return Apollo.useLazyQuery<GetFundQuery, GetFundQueryVariables>(
    GetFundDocument,
    baseOptions,
  );
}
export type GetFundQueryHookResult = ReturnType<typeof useGetFundQuery>;
export type GetFundLazyQueryHookResult = ReturnType<typeof useGetFundLazyQuery>;
export type GetFundQueryResult = Apollo.QueryResult<
  GetFundQuery,
  GetFundQueryVariables
>;
export const GetFundInvestmentsDocument = gql`
  query GetFundInvestments($id: UUID!) {
    fundInvestments(fundId: $id) {
      id
      status
      investedCapital
      ownershipPercent
      nav
      ev
      multiple
      irr
      company {
        name
        documentId
      }
    }
  }
`;

/**
 * __useGetFundInvestmentsQuery__
 *
 * To run a query within a React component, call `useGetFundInvestmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundInvestmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundInvestmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFundInvestmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFundInvestmentsQuery,
    GetFundInvestmentsQueryVariables
  >,
) {
  return Apollo.useQuery<
    GetFundInvestmentsQuery,
    GetFundInvestmentsQueryVariables
  >(GetFundInvestmentsDocument, baseOptions);
}
export function useGetFundInvestmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFundInvestmentsQuery,
    GetFundInvestmentsQueryVariables
  >,
) {
  return Apollo.useLazyQuery<
    GetFundInvestmentsQuery,
    GetFundInvestmentsQueryVariables
  >(GetFundInvestmentsDocument, baseOptions);
}
export type GetFundInvestmentsQueryHookResult = ReturnType<
  typeof useGetFundInvestmentsQuery
>;
export type GetFundInvestmentsLazyQueryHookResult = ReturnType<
  typeof useGetFundInvestmentsLazyQuery
>;
export type GetFundInvestmentsQueryResult = Apollo.QueryResult<
  GetFundInvestmentsQuery,
  GetFundInvestmentsQueryVariables
>;
export const GetFundScenariosDocument = gql`
  query GetFundScenarios($id: UUID!) {
    fundScenarios(fundId: $id) {
      id
      defaultDilution
      defaultExitDate
      position
      name
    }
  }
`;

export const GetFundScenariosPage = gql`
  query GetFundScenarios($id: UUID!) {
    fundScenarios(fundId: $id) {
      id
      defaultDilution
      defaultExitDate
      calculationStatus
      position
      name
      bookValue
      grossIrr
      grossMultiple
      investedCapital
    }
  }
`;

/**
 * __useGetFundScenariosQuery__
 *
 * To run a query within a React component, call `useGetFundScenariosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundScenariosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundScenariosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFundScenariosQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetFundScenariosQuery,
    GetFundScenariosQueryVariables
  >,
) {
  return Apollo.useQuery<GetFundScenariosQuery, GetFundScenariosQueryVariables>(
    GetFundScenariosDocument,
    baseOptions,
  );
}
export function useGetFundScenariosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetFundScenariosQuery,
    GetFundScenariosQueryVariables
  >,
) {
  return Apollo.useLazyQuery<
    GetFundScenariosQuery,
    GetFundScenariosQueryVariables
  >(GetFundScenariosDocument, baseOptions);
}
export type GetFundScenariosQueryHookResult = ReturnType<
  typeof useGetFundScenariosQuery
>;
export type GetFundScenariosLazyQueryHookResult = ReturnType<
  typeof useGetFundScenariosLazyQuery
>;
export type GetFundScenariosQueryResult = Apollo.QueryResult<
  GetFundScenariosQuery,
  GetFundScenariosQueryVariables
>;
